import React, { useContext } from 'react';
import isEmpty from 'lodash/isEmpty';
import { Button, Icon, IconButton, SwanIconKey } from '@vp/swan';
import Pages from '../data/Pages';
import RouterContext from '../utils/RouterContext';
import { defineMessages } from '@vistaprint-org/digital-i18n-utils';
import { useTranslation } from 'react-i18next';

interface LinkButtonProps {
  to?: Pages;
  text?: string;
  iconType?: SwanIconKey;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
const messages = defineMessages({
  buttonAriaLabel: 'Back Button',
});

const LinkButton: React.FC<LinkButtonProps> = (props: LinkButtonProps) => {
  const { changePage } = useContext(RouterContext);
  const { t } = useTranslation();
  const label = t(messages.buttonAriaLabel.id);
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (props.onClick) {
      props.onClick(e);
    }
    if (props.to) {
      changePage(props.to);
    }
  };

  if (isEmpty(props.text)) {
    return (
      <IconButton tooltip={label} aria-label={label} onClick={handleClick}>
        {!isEmpty(props.iconType) && <Icon iconType={props.iconType} />}
      </IconButton>
    );
  }

  return (
    <Button aria-label={label} role="button" onClick={handleClick}>
      {props.text}
      {!isEmpty(props.iconType) && <Icon iconType={props.iconType} />}
    </Button>
  );
};

export default LinkButton;
